import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../../store/slices/authSlice'
import { ROUTES, TEMPLATE_TAB_PATHS } from '../../constants/routes.js'

export default function RoleRoute({ allowedRoles, children }) {
  const user = useSelector(selectUser)
  const currentRole = user?.role?.toLowerCase()

  if (!allowedRoles.includes(currentRole)) {
    return <Navigate to={`${ROUTES.TEMPLATES}/${TEMPLATE_TAB_PATHS.MY_TEMPLATES}`} replace />
  }

  return children
}
